"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpEventDrivenServer = void 0;
const types_1 = require("../types");
class HttpEventDrivenServer {
    constructor(eventBus) {
        this.eventBus = eventBus;
        this.listener = (_a) => __awaiter(this, [_a], void 0, function* ({ data }) {
            if (data) {
                const fetchResponse = yield this.doRequest(data);
                this.eventBus.publish(types_1.FetchTypeMap.FETCH_RESPONSE, new types_1.FetchResponseEvent(fetchResponse));
            }
        });
        this.eventBus.subscribe(types_1.FetchTypeMap.FETCH, this.listener);
    }
}
exports.HttpEventDrivenServer = HttpEventDrivenServer;
//# sourceMappingURL=HttpEventDrivenServer.js.map